/** @format */

import {styled} from '@mui/material/styles';
import {Box, Link, Typography} from '@mui/material';

const LINE_HEIGHT = 16;
const LINE_GAP = 8;
const MAX_LINES = 10;

const maxHeight = LINE_HEIGHT * MAX_LINES + LINE_GAP * (MAX_LINES - 1);

export const Root = styled(Box)(({theme}) => ({
  borderRadius: '8px',
  background: theme.palette.figma_gray_light_4?.main,
  padding: theme.spacing(4, 0),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
}));

export const RegularText = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_gray_dark_5?.main,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
  flexShrink: 0,
}));

export const BiggerText = styled(Typography)(({theme}) => ({
  color: theme.palette.figma_gray_dark_5?.main,
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '20px',
}));

export const ContentBox = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(0, 4),
}));

export const LinkButton = styled(Link)(({theme}) => ({
  height: '32px',
  borderRadius: '8px',
  background: '#4A4B4F',
  color: theme.palette.figma_gray_light_4?.main,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '16px',
  padding: theme.spacing(0, 4),
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  gap: theme.spacing(2),
}));

export const DetailRow = styled(Box)(({theme}) => ({
  height: `${LINE_HEIGHT}px`,
  width: '200px',
  display: 'flex',
  justifyContent: 'space-between',
  gap: theme.spacing(1),
}));

export const DotsBox = styled(Box)(() => ({
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'center',
}));

interface ScrollBoxProps {
  elementsCount: number;
}

export const ScrollBox = styled(Box, {
  shouldForwardProp: prop => prop !== 'elementsCount',
})<ScrollBoxProps>(({theme, elementsCount}) => ({
  maxHeight: `${maxHeight}px`,
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  gap: `${LINE_GAP}px`,
  padding: theme.spacing(0, 4),

  // Исправляет баг с лишней прокруткой
  height: `${elementsCount * (LINE_HEIGHT + LINE_GAP) - LINE_GAP + 1}px`,
}));
